var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Availability } from 'stores/carePlanDraft';
var CheckMark = function () { return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "10", height: "10", fill: "none", children: _jsx("path", { fill: "#52C41A", d: "M5.039.038a4.961 4.961 0 1 0-.001 9.923 4.961 4.961 0 0 0 0-9.923Zm2.244 4.105-2.48 2.481a.54.54 0 0 1-.768 0l-1.24-1.24a.544.544 0 0 1 .767-.768l.857.857 2.097-2.097a.543.543 0 0 1 .767.767Z" }) })); };
var CrossMark = function () { return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "11", height: "11", fill: "none", children: _jsx("path", { fill: "#E22020", d: "M5.783 0a5.217 5.217 0 1 0-.001 10.434A5.217 5.217 0 0 0 5.782 0Zm1.632 6.175a.489.489 0 1 1-.691.692l-.941-.959-.959.959a.489.489 0 1 1-.691-.692l.958-.958-.959-.976a.489.489 0 1 1 .692-.692l.959.977.958-.958a.489.489 0 1 1 .692.692l-.958.958.94.957Z" }) })); };
var QuestionMark = function () { return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "11", height: "12", fill: "none", children: [_jsx("path", { fill: "#fff", d: "M3.87 2.935h7v9h-7z" }), _jsx("path", { fill: "#D48806", d: "M5.935.935a5.065 5.065 0 1 0 0 10.13 5.065 5.065 0 0 0 0-10.13Zm0 8.005a.452.452 0 1 1 0-.905.452.452 0 0 1 0 .905Zm.711-2.482a.546.546 0 0 0-.35.506v.257c0 .05-.04.09-.09.09h-.542a.09.09 0 0 1-.09-.09v-.243a1.264 1.264 0 0 1 .814-1.196c.384-.148.632-.47.632-.822 0-.499-.487-.905-1.085-.905s-1.085.406-1.085.905v.086c0 .05-.04.09-.09.09h-.543a.09.09 0 0 1-.09-.09V4.96c0-.444.194-.86.546-1.168.34-.297.787-.46 1.262-.46s.923.164 1.262.46c.353.309.547.724.547 1.168 0 .653-.43 1.241-1.098 1.498Z" })] })); };
var Icons = (_a = {},
    _a[Availability.YES] = CheckMark,
    _a[Availability.NO] = CrossMark,
    _a[Availability.UNKNOWN] = QuestionMark,
    _a);
var AvailabilityStateIcons = function (_a) {
    var loading = _a.loading, state = _a.state, isEmptyUnknown = _a.isEmptyUnknown;
    if (loading) {
        return _jsx(Spin, { indicator: _jsx(LoadingOutlined, { spin: true }), size: "small" });
    }
    if (state) {
        var Icon = Icons[state];
        return _jsx(Icon, {});
    }
    if (isEmptyUnknown) {
        var UnknownState = Icons[Availability.UNKNOWN];
        return _jsx(UnknownState, {});
    }
    return null;
};
export default AvailabilityStateIcons;
